<div class="calculator">
  <div class="calculator__equation">{{ equation }}</div>
  <input class="calculator__display" [(ngModel)]="display" readonly />
  <div class="calculator__buttons">
    <button (click)="clear()">C</button>
    <button (click)="appendNumber(7)">7</button>
    <button (click)="appendNumber(8)">8</button>
    <button (click)="appendNumber(9)">9</button>
    <button (click)="selectOperation('+')">+</button>
    <button (click)="appendNumber(4)">4</button>
    <button (click)="appendNumber(5)">5</button>
    <button (click)="appendNumber(6)">6</button>
    <button (click)="selectOperation('-')">-</button>
    <button (click)="appendNumber(1)">1</button>
    <button (click)="appendNumber(2)">2</button>
    <button (click)="appendNumber(3)">3</button>
    <button (click)="selectOperation('*')">*</button>
    <button (click)="appendNumber(0)">0</button>
    <button (click)="appendDot()">.</button>
    <button (click)="equals()">=</button>
    <button (click)="selectOperation('/')">/</button>
  </div>
  <button class="calculator__save" (click)="saveResult()">Save Result</button>
</div>
<div class="saved-results">
  <h3>Saved Results</h3>
  <ul>
    <li *ngFor="let result of savedResults; let i = index">
      {{ result }}
      <button class="delete-button" (click)="deleteResult(i)">×</button>
    </li>
  </ul>
  <p>Total: {{ getTotal() }}</p>
</div>
